import React, { useState } from 'react';
import { ListItem, ListItemIcon, ListItemText, Collapse, useTheme, IconButton, Button } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Link, Navigate, useNavigate } from 'react-router-dom';

interface SidebarItemProps {
  index: number;
  text: string;
  icon: React.ReactElement;
  selectedIndex: number | null;
  handleListItemClick: (index: number) => void;
  path: string;
  subItems?: { text: string; icon: React.ReactElement; path: string }[];
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  index,
  text,
  icon,
  selectedIndex,
  handleListItemClick,
  path,
  subItems,
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const handleClick = () => {
    handleListItemClick(index);
    if(!subItems)     navigate(path);
    if (subItems) {
      setOpen(!open);
    }
  };

  return (
    <>
      <ListItem
        component={Button}
        className="cursor-pointer hover:bg-gray-100"
        onClick={handleClick}
        style={{ 
          color: selectedIndex === index ? theme.palette.primary.main : theme.palette.text.secondary,
        }}
      >
        <ListItemIcon style={{ color: selectedIndex === index ? theme.palette.primary.main : theme.palette.text.secondary }}>
          {icon}
        </ListItemIcon>
        <ListItemText primary={text} />
        {subItems && (open ?  <ExpandLess /> : <ExpandMore />)}
      </ListItem>
      {subItems && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          {subItems.map((subItem, subIndex) => (
            <div key={subIndex} className="flex">
              <div className="w-1/12"></div>
              <ListItem
                component={Link}
                to={subItem.path}
                className="w-11/12 cursor-pointer hover:bg-gray-100"
                onClick={() => handleListItemClick(index + subIndex + 1)}
                style={{ 
                  color: selectedIndex === index + subIndex + 1 ? theme.palette.primary.main : theme.palette.text.secondary,
                }}
              >
                <ListItemIcon style={{ color: selectedIndex === index + subIndex + 1 ? theme.palette.primary.main : theme.palette.text.secondary }}>
                  {subItem.icon}
                </ListItemIcon>
                <ListItemText primary={subItem.text} />
              </ListItem>
            </div>
          ))}
        </Collapse>
      )}
    </>
  );
};

export default SidebarItem;
